import React from 'react';
import { Shield, CreditCard, Lock } from 'lucide-react';

/**
 * Small "Powered by PayPal" trust badge for checkout surfaces (Deal Bin, Upgrade).
 * Non-interactive, stateless, drop-in.
 */
export default function PayPalTrustBadge({ compact = false }) {
  if (compact) {
    return (
      <div data-testid="paypal-trust-badge" className="inline-flex items-center gap-1.5 text-[10px] text-gray-500">
        <Lock size={10} /> Secure checkout by <span className="font-semibold text-blue-300 tracking-tight">Pay<span className="text-blue-500">Pal</span></span>
      </div>
    );
  }
  return (
    <div data-testid="paypal-trust-badge" className="flex items-center gap-3 rounded-lg border border-[#1f1f1f] bg-[#0a0a0a] px-4 py-3">
      <div className="w-8 h-8 rounded-md bg-blue-500/10 border border-blue-500/25 flex items-center justify-center shrink-0">
        <Shield className="text-blue-300" size={16} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold">
          Powered by <span className="text-blue-300 tracking-tight">Pay<span className="text-blue-500">Pal</span></span>
        </div>
        <div className="text-[11px] text-gray-500">
          Encrypted checkout · Card, debit, and PayPal wallet all accepted · You never share card details with the site.
        </div>
      </div>
      <div className="hidden sm:flex items-center gap-1.5 text-[10px] text-gray-500">
        <CreditCard size={12} /> Card · PayPal
      </div>
    </div>
  );
}
